document.addEventListener('DOMContentLoaded', function() {
    var filterRoots = document.querySelectorAll('[data-catalog-filters]');
    var adultToggle = document.querySelector('[data-adult-toggle]');

    if (adultToggle) {
        adultToggle.addEventListener('click', function() {
            document.querySelectorAll('.v2-channel-card--adult, .v2-mobile-card--adult').forEach(function(card) {
                card.classList.remove('v2-channel-card--adult');
                card.classList.remove('v2-mobile-card--adult');
            });
            adultToggle.remove();
        });
    }

    filterRoots.forEach(function(root) {
        var form = root.querySelector('form');
        var status = root.querySelector('[data-filter-status]');
        var slugMap = JSON.parse(root.dataset.slugMap || '{}');
        var baseUrl = root.dataset.baseUrl;
        var applyTimeout = null;
        var isMobile = root.dataset.filterMode === 'mobile';
        var openButton = root.querySelector('[data-mobile-filters-open]');
        var closeButton = root.querySelector('[data-mobile-filters-close]');
        var overlay = root.querySelector('[data-mobile-filters-overlay]');
        var sheet = root.querySelector('[data-mobile-filters-sheet]');

        if (!form || !baseUrl) {
            return;
        }

        function toggleMobileFilters(shouldOpen) {
            if (!isMobile || !overlay || !sheet) {
                return;
            }

            root.classList.toggle('is-open', shouldOpen);
            overlay.hidden = !shouldOpen;
            sheet.hidden = !shouldOpen;
            document.body.classList.toggle('v2-mobile-filters-open', shouldOpen);
        }

        if (isMobile && openButton && closeButton && overlay && sheet) {
            openButton.addEventListener('click', function() {
                toggleMobileFilters(true);
            });

            closeButton.addEventListener('click', function() {
                toggleMobileFilters(false);
            });

            overlay.addEventListener('click', function() {
                toggleMobileFilters(false);
            });
        }

        function collectFilters() {
            var filters = {};
            var typeChecked = Array.prototype.slice.call(form.querySelectorAll('input[name="type[]"]:checked'));
            if (typeChecked.length) {
                filters.type = typeChecked.map(function(el) {
                    return el.value;
                });
            }

            ['size', 'freq', 'err'].forEach(function(name) {
                var selected = form.querySelector('input[name="' + name + '"]:checked');
                if (selected && selected.value) {
                    filters[name] = selected.value;
                }
            });

            return filters;
        }

        function withPathSegments(urlString, segments) {
            var url = new URL(urlString, window.location.origin);
            var cleanBase = url.pathname.replace(/\/+$/, '');
            url.pathname = cleanBase + (segments.length ? '/' + segments.join('/') : '');
            return url.toString();
        }

        function buildQueryUrl(filters) {
            var url = new URL(baseUrl, window.location.origin);
            var params = new URLSearchParams();

            if (filters.type) {
                filters.type.forEach(function(value) {
                    params.append('type[]', value);
                });
            }

            ['size', 'freq', 'err'].forEach(function(name) {
                if (filters[name]) {
                    params.set(name, filters[name]);
                }
            });

            url.search = params.toString();
            return url.toString();
        }

        function buildSlugUrl(filters) {
            var slugParts = [];

            ['type', 'size', 'freq', 'err'].forEach(function(name) {
                if (!filters[name]) {
                    return;
                }

                if (Array.isArray(filters[name]) && filters[name].length > 1) {
                    slugParts = null;
                    return;
                }

                var value = Array.isArray(filters[name]) ? filters[name][0] : filters[name];
                var slug = slugMap[name] && slugMap[name][value];
                if (!slug) {
                    slugParts = null;
                    return;
                }

                slugParts.push(slug);
            });

            if (!slugParts || slugParts.length > 2) {
                return buildQueryUrl(filters);
            }

            return withPathSegments(baseUrl, slugParts);
        }

        function applyFilters() {
            var filters = collectFilters();
            if (status) {
                status.classList.add('is-visible');
            }
            if (isMobile) {
                toggleMobileFilters(false);
            }
            window.location.href = Object.keys(filters).length ? buildSlugUrl(filters) : baseUrl;
        }

        if (!isMobile) {
            form.addEventListener('change', function() {
                window.clearTimeout(applyTimeout);
                applyTimeout = window.setTimeout(applyFilters, 450);
            });
        }

        form.addEventListener('submit', function(event) {
            event.preventDefault();
            window.clearTimeout(applyTimeout);
            applyFilters();
        });
    });
});
